import React, { useState } from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

// Arrow button component
const ArrowButton = ({ onClick, direction }) => (
  <div
    onClick={onClick}
    style={{
      ...arrowStyle,
      [direction]: "-25px",
    }}
  >
    {direction === "left" ? "‹" : "›"}
  </div>
);

// Styles for arrows
const arrowStyle = {
  position: "absolute",
  top: "50%",
  transform: "translateY(-50%)",
  zIndex: 2,
  fontSize: "32px",
  color: "#124178",
  cursor: "pointer",
  padding: "5px 10px",
  userSelect: "none",
};

// Limit for content truncation
const MAX_CONTENT_LENGTH = 125;

const StoryCarousal = ({ storyData }) => {
  const [expandedId, setExpandedId] = useState(null);
  const isSingleStory = storyData.length <= 1;

  const handleToggle = (id) => {
    setExpandedId(expandedId === id ? null : id);
  };

  const settings = {
    dots: !isSingleStory,
    infinite: !isSingleStory,
    speed: 500,
    arrows: !isSingleStory,
    autoplay: !isSingleStory,
    autoplaySpeed: 3000,
    slidesToShow: 1,
    slidesToScroll: 1,
    nextArrow: <ArrowButton direction="right" />,
    prevArrow: <ArrowButton direction="left" />,
    appendDots: (dots) => (
      <div style={{ marginTop: "12px" }}>
        <ul style={{ display: "flex", justifyContent: "center", gap: "8px" }}>
          {dots}
        </ul>
      </div>
    ),
    customPaging: () => <div className="custom-dot" />,
  };

  if (!storyData || storyData.length === 0) {
    return (
      <p style={{ fontSize: "14px", textAlign: "center" }}>
        No stories available.
      </p>
    );
  }

  return (
    <div style={{ maxWidth: "320px", margin: "auto", position: "relative" }}>
      <Slider {...settings}>
        {storyData.map((item) => {
          const isLong = item.content.length > MAX_CONTENT_LENGTH;
          const isExpanded = expandedId === item.id;
          const displayText = isExpanded
            ? item.content
            : isLong
            ? item.content.slice(0, MAX_CONTENT_LENGTH) + "..."
            : item.content;

          return (
            <div key={item.id}>
              <div
                style={{
                  padding: "16px",
                  borderRadius: "12px",
                  minHeight: "130px",
                  textAlign: "left",
                  boxShadow: "0 2px 8px rgba(0, 0, 0, 0.05)",
                  backgroundColor: "#fff",
                }}
              >
                <p style={{ fontSize: "14px", marginBottom: "6px" }}>
                  {displayText}
                </p>

                {isLong && (
                  <span
                    onClick={() => handleToggle(item.id)}
                    style={{
                      fontSize: "13px",
                      color: "#007bff",
                      cursor: "pointer",
                      display: "inline-block",
                    }}
                  >
                    {isExpanded ? "Read Less" : "Read More"}
                  </span>
                )}
              </div>
            </div>
          );
        })}
      </Slider>

      {/* Custom dot styles */}
      <style>{`
        .custom-dot {
          width: 8px;
          height: 8px;
          background-color: #124178;
          border-radius: 50%;
          transition: all 0.3s ease;
        }
        .slick-dots li.slick-active .custom-dot {
          background-color: #ff5722;
          width: 10px;
          height: 10px;
        }
      `}</style>
    </div>
  );
};

export default StoryCarousal;

// import React, { useState } from "react";
// import Slider from "react-slick";
// import "slick-carousel/slick/slick.css";
// import "slick-carousel/slick/slick-theme.css";

// // Arrow button styles
// const ArrowButton = ({ onClick, direction }) => (
//   <div
//     onClick={onClick}
//     style={{
//       ...arrowStyle,
//       [direction]: "-25px",
//     }}
//   >
//     {direction === "left" ? "‹" : "›"}
//   </div>
// );

// const arrowStyle = {
//   position: "absolute",
//   top: "50%",
//   transform: "translateY(-50%)",
//   zIndex: 2,
//   fontSize: "32px",
//   color: "#124178",
//   cursor: "pointer",
//   padding: "5px 10px",
//   userSelect: "none",
// };

// const MAX_CONTENT_LENGTH = 125;

// const StoryCarousal = ({ storyData }) => {
//   const [expandedId, setExpandedId] = useState(null);

//   const handleToggle = (id) => {
//     setExpandedId(expandedId === id ? null : id);
//   };

//   const settings = {
//     dots: true,
//     infinite: true,
//     speed: 500,
//     arrows: true,
//     autoplay: true,
//     autoplaySpeed: 3000,
//     slidesToShow: 1,
//     slidesToScroll: 1,
//     nextArrow: <ArrowButton direction="right" />,
//     prevArrow: <ArrowButton direction="left" />,
//     appendDots: (dots) => (
//       <div style={{ marginTop: "12px" }}>
//         <ul style={{ display: "flex", justifyContent: "center", gap: "8px" }}>
//           {dots}
//         </ul>
//       </div>
//     ),
//     customPaging: (i) => <div className="custom-dot" />,
//   };

//   return (
//     <div style={{ maxWidth: "320px", margin: "auto", position: "relative" }}>
//       <Slider {...settings}>
//         {storyData.map((item) => {
//           const isLong = item.content.length > MAX_CONTENT_LENGTH;
//           const isExpanded = expandedId === item.id;
//           const displayText = isExpanded
//             ? item.content
//             : isLong
//             ? item.content.slice(0, MAX_CONTENT_LENGTH) + "..."
//             : item.content;

//           return (
//             <div key={item.id}>
//               <div
//                 style={{
//                   padding: "16px",
//                   // backgroundColor: "#fff",
//                   borderRadius: "12px",
//                   minHeight: "130px",
//                   textAlign: "left",
//                   boxShadow: "0 2px 8px rgba(0, 0, 0, 0.05)",
//                 }}
//               >
//                 <p style={{ fontSize: "14px", marginBottom: "6px" }}>
//                   {displayText}
//                 </p>

//                 {isLong && (
//                   <span
//                     onClick={() => handleToggle(item.id)}
//                     style={{
//                       fontSize: "13px",
//                       color: "#007bff",
//                       cursor: "pointer",
//                       display: "inline-block",
//                     }}
//                   >
//                     {isExpanded ? "Read Less" : "Read More"}
//                   </span>
//                 )}
//               </div>
//             </div>
//           );
//         })}
//       </Slider>

//       {/* Custom dot styles */}
//       <style>{`
//         .custom-dot {
//           width: 8px;
//           height: 8px;
//           background-color: #124178;
//           border-radius: 50%;
//           transition: all 0.3s ease;
//         }
//         .slick-dots li.slick-active .custom-dot {
//           background-color: #ff5722;
//           width: 10px;
//           height: 10px;
//         }
//       `}</style>
//     </div>
//   );
// };

// export default StoryCarousal;
